import {
  ref,
  computed,
  reactive,
  // watch,
  // xxx
} from '@vue/composition-api'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import store from '@/store'
// import axios from 'axios'
import {
  URL,
  // USER,
  INSERT_DATA_PLAYER,
  INSERT_DATA_HISTORY_PLAYER,
  UPDATE_DATA_PLAYER,
  ESTADO_JUGADOR,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default function useInscription() {
  const { getApi } = apiCall()
  const listGremios = ref([])
  const listArbitros = ref([])
  const listArbitrosSearch = ref([])
  const searchQuery = ref('')
  // const totalInscritos= ref(0)
  // const totalRevisados= ref(0)
  const categoriaAdmin = ref(null)
  const gremioSeleccionada = ref({ label: 'Seleccione Equipo', isInReview: false })
  const refInvoiceListTable = ref(null)
  const showLoading = ref(false)
  const arbitroData = reactive({
    ci_pasaporte: '',
    direccion: null,
    email: null,
    fecha_nac: '',
    id_gremio_arbitral: '',
    nombre: '',
    telefono: null,
    estado_arbitro: 'inscrito',
    id_arbitro: null,
  })
  // const playerSelected = reactive({})

  const tableColumns = [
    { key: 'arbitro', sortable: true },
    // { key: 'nombre', sortable: true },
    { key: 'fecha_nac', label: 'Fecha.Nacimiento', sortable: true },
    // { key: 'categoria', sortable: true },
    // { key: 'tipo_jugador', label: 'T.J', sortable: true },
    // { key: 'estado_jug', sortable: true },
    { key: 'acciones' },
  ]

  async function getlistGremios() {
    listGremios.value = []
    const path = 'ApiArbitros/getGremios'
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      data.data.forEach(element => {
        const obj = {
          label: `${element.apodo} `,
          value: element.id_gremio_arbitral,
        }
        listGremios.value.push(obj)
      })
    } else {
      listGremios.value = []
    }
  }

  async function getArbitros(idEquipo) {
    listArbitros.value = []
    showLoading.value = true
    const path = `ApiArbitros/getArbitros/${idEquipo}`
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      listArbitros.value = data.data
    } else {
      listArbitros.value = []
    }
    showLoading.value = false
  }

  async function getArbitrosCedula(cedula) {
    listArbitrosSearch.value = []
    const path = `ApiArbitros/getArbitrosCedula/${cedula}`
    const data = await getApi(URL, path)
    if (data.flag === 'si') {
      listArbitrosSearch.value = data.data
    } else {
      listArbitrosSearch.value = []
    }
  }

  const listPlayersFilter = computed(() => listArbitros.value.filter(
    player => player.nombre
      .toLowerCase()
      .includes(searchQuery.value.toLowerCase())
      // eslint-disable-next-line
      || player.ci_pasaporte
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase()),
  ))

  const totalInscritos = computed(() => listPlayersFilter.value.length)

  function changeGremio(item) {
    // console.log(item)
    gremioSeleccionada.value = item
    getArbitros(item.value)
    arbitroData.id_gremio_arbitral = item.value
  }

  function getTotal() {
    const list = listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.CALIFICADO)
    return list.length
  }
  // async function updateSolicitudRevision(idInscripcion) {
  //   const path = 'ApiConfiguration/updateInscripcionEquipo'
  //   const response = await postApi(URL, path, idInscripcion)
  //   if (response.flag === 'si') {
  //     this.$toast(
  //       {
  //         component: ToastificationContent,
  //         props: {
  //           title: 'REVISION EXITOSA',
  //           icon: 'AlertCircleIcon',
  //           variant: 'success',
  //           solid: true,
  //         },
  //       },
  //       {
  //         position: 'bottom-center',
  //         // eslint-disable-next-line
  //       }
  //     )
  //     salirRevision()
  //   } else {
  //     this.$toast(
  //       {
  //         component: ToastificationContent,
  //         props: {
  //           title: 'ERROR no se pudo actualizar',
  //           icon: 'AlertCircleIcon',
  //           variant: 'danger',
  //           solid: true,
  //         },
  //       },
  //       {
  //         position: 'top-center',
  //         // eslint-disable-next-line
  //       }
  //     )
  //   }
  // }
  // async function uploadExcel(fileData) {
  //   console.log(arbitroData.id_equipo)
  //   const archivo = new FormData()
  //   archivo.append('file', fileData)
  //   archivo.append('id_equipo', arbitroData.id_equipo)
  //   archivo.append('totalInscritos', 2)
  //   const path = 'ApiInscripciones/exel'
  //   const response = await postApiFormData(URL, path, archivo)
  //   console.log(response)
  // }

  return {
    tableColumns,
    // listEquipos,
    listArbitros,
    listGremios,
    getlistGremios,
    getArbitros,
    changeGremio,
    searchQuery,
    refInvoiceListTable,
    listPlayersFilter,
    getArbitrosCedula,
    listArbitrosSearch,
    // playerSelected,
    arbitroData,
    INSERT_DATA_PLAYER,
    INSERT_DATA_HISTORY_PLAYER,
    UPDATE_DATA_PLAYER,
    categoriaAdmin,
    showLoading,
    // updateSolicitudRevision,
    gremioSeleccionada,
    getTotal,
    totalInscritos,
    // uploadExcel,
  }
}
